import { Box, Button } from '@factorialco/deprecated-design-system'

import PopoverMenu from 'modules/core/components/PopoverMenu'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

interface ActionsProps {
  ledgerAccountId: number
  disabled: boolean
  onShowEditClick: () => void
  onShowDeleteClick: () => void
  onShowEnableDisableClick: () => void
  canManageJournalEntries: boolean
}

interface PopoverProps {
  disabled: boolean
  onShowEditClick: () => void
  onShowDeleteClick: () => void
  onShowEnableDisableClick: () => void
  canManageJournalEntries: boolean
}

const Popover = ({
  disabled,
  onShowEditClick,
  onShowDeleteClick,
  onShowEnableDisableClick,
  canManageJournalEntries,
}: PopoverProps) => {
  const actions = () => {
    return (
      <>
        <PopoverMenu.TouchableOption
          onClick={onShowEditClick}
          title={i18n.t('finance.chart_of_accounts.actions.edit.title')}
          description={i18n.t('finance.chart_of_accounts.actions.edit.description')}
        />
        {canManageJournalEntries && (
          <PopoverMenu.TouchableOption
            onClick={onShowEnableDisableClick}
            title={
              disabled
                ? i18n.t('finance.chart_of_accounts.actions.activate.title')
                : i18n.t('finance.chart_of_accounts.actions.deactivate.title')
            }
            description={
              disabled
                ? i18n.t('finance.chart_of_accounts.actions.activate.description')
                : i18n.t('finance.chart_of_accounts.actions.deactivate.description')
            }
          />
        )}
        <PopoverMenu.TouchableOption
          onClick={onShowDeleteClick}
          title={i18n.t('finance.buttons.delete')}
          danger
        />
      </>
    )
  }

  return (
    <PopoverMenu type="list">
      <PopoverMenu.Trigger>
        <Button.Decorative type="secondary" iconName="ellipsis" />
      </PopoverMenu.Trigger>
      <PopoverMenu.Content side="bottom" align="end">
        {actions()}
      </PopoverMenu.Content>
    </PopoverMenu>
  )
}

const Actions = ({
  ledgerAccountId,
  disabled,
  onShowEditClick,
  onShowDeleteClick,
  onShowEnableDisableClick,
  canManageJournalEntries,
}: ActionsProps) => {
  const { navigation } = useNavigation()
  return (
    <Box gap="s4" flexDirection="row" justifyContent="flexEnd">
      <Popover
        disabled={disabled}
        onShowEditClick={onShowEditClick}
        onShowEnableDisableClick={onShowEnableDisableClick}
        onShowDeleteClick={onShowDeleteClick}
        canManageJournalEntries={canManageJournalEntries}
      />
      {canManageJournalEntries && (
        <Button.Router
          type="secondary"
          to={navigation.finance.accounting.ledgerAccountId.fullPath({
            ledgerAccountId,
          })}
          iconName="arrow-right"
        />
      )}
    </Box>
  )
}

export default Actions
